import React from 'react';
import { COLORS } from '../../styles/tokens';

// Liten merkelapp for oppdrag som betales på faktura. Rendrer ingenting for andre oppdrag.
export default function InvoiceBadge({ order, style }) {
  if (order?.paymentMethod !== 'invoice') return null;
  return <span style={{ ...styles.badge, ...style }}>Faktura</span>;
}

const styles = {
  badge: {
    // Temavariabler (lys, krem og mørk) i stedet for en fast lys farge, så merket er lesbart i mørk modus
    display: 'inline-block', background: COLORS.surfaceHover, color: COLORS.textDark,
    border: `1px solid ${COLORS.border}`, borderRadius: 10,
    padding: '2px 8px', fontSize: 11, fontWeight: 700, letterSpacing: 0.3, whiteSpace: 'nowrap',
  },
};
